export enum BankAccountTypesEnum {
    Checking = "Checking",
    Savings = "Savings",
    BusinessChecking = "Business Checking",
  }